import React from 'react';
import { QuoteWidgetItem } from '../../../../recently-viewed/src/template/src/quote-widget-items';
import { FavouritedData } from '@atlassian/cssxp-typescommon';

type Quotes = FavouritedData[];

export const getFavouritedQuoteWidgetContent = (quotes: Quotes) => {
  if (!quotes || !quotes.length) {
    return <div style={{ marginTop: '15px' }}>No Quotes marked as favorites yet</div>;
  }

  return quotes.map((quote, index) => {
    return <QuoteWidgetItem key={index} {...quote} />;
  });
};
